module.exports = __webpack_public_path__ + "media/assets/images/blog/girl_couch-82e99a610906a8552e2f65554a3061d4.jpeg";